import React from 'react'
import API from 'lib/api'
import { LINKPASS_ADMIN_URL } from 'config/app'

const resolvePromises = async (apiCallArray) => {
  return Promise.all(apiCallArray)
}

export const useGetUserObject = (uid) => {
  const [userObj, setUserObj] = React.useState({
    'linkpass-profile': {},
    'auth0-profile': {},
  })

  const linkpassAdminApi = new API({
    url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/uid/${uid}`,
  })

  const auth0ProfileApi = new API({
    url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/uid/${uid}/auth0`,
  })

  React.useEffect(() => {
    const apiCalls = [
      linkpassAdminApi
        .get()
        .then((res) => res)
        .catch((err) => err),
      auth0ProfileApi
        .get()
        .then((res) => res)
        .catch((err) => err),
    ]

    resolvePromises(apiCalls).then((res) => {
      // handle empty link profile
      setUserObj({
        'linkpass-profile': res[0],
        'auth0-profile': res[1],
      })
    })
  }, [])

  return userObj
}
